/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSchema } from '../../models/document-schema';

export interface ApiDocumentSchemasSchemasGet$Plain$Params {
}

export function apiDocumentSchemasSchemasGet$Plain(http: HttpClient, rootUrl: string, params?: ApiDocumentSchemasSchemasGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchema>>> {
  const rb = new RequestBuilder(rootUrl, apiDocumentSchemasSchemasGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentSchema>>;
    })
  );
}

apiDocumentSchemasSchemasGet$Plain.PATH = '/api/DocumentSchemas/schemas';
